var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "confirm-page" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.pageDataFetched
        ? _c(
            "div",
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "body" } },
                [
                  !_vm.isPmUpdate
                    ? [
                        _vm.paymentMethod === "BACS"
                          ? [
                              _c("div", { staticClass: "col xs-12" }, [
                                _c("div", {
                                  staticStyle: {
                                    width: "100%",
                                    margin: "0 auto",
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.checkoutSharedContent.bacsGuarantee
                                    ),
                                  },
                                }),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayUpsellCTA
                          ? [
                              _c("p", { attrs: { id: "upsell-message" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.checkoutSharedContent.confirmation_page
                                      .upsell_message
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row center-xs" }, [
                                _c("div", { staticClass: "col xs-12" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.checkoutSharedContent
                                        .webstoreDemo.fields.file.url,
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.smallFleetOpportunity
                          ? [
                              _c(
                                "div",
                                { attrs: { id: "webinar-sign-up-container" } },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "small-fleet-messaging" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.checkoutSharedContent
                                              .confirmation_page
                                              .smallFleetsMessagingHeader
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "mb-10 small-fleets-button",
                                      attrs: {
                                        href: _vm.checkoutSharedContent
                                          .confirmation_page
                                          .smallFleetsSignUpLink,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixPanelTrackingConfirmPage(
                                            _vm.CTAPath
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.checkoutSharedContent
                                              .confirmation_page
                                              .smallFleetsButtonMessaging
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm.displayWebinarCTA
                          ? [
                              _c(
                                "div",
                                { attrs: { id: "webinar-sign-up-container" } },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        id: "webinar-sign-up",
                                        href: "https://kb.samsara.com/hc/en-us/articles/360050215112?utm_source=webstore&utm_medium=thank-you-page&utm_campaign=add-ons",
                                        target: "_blank",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mixPanelTrackingConfirmPage(
                                            _vm.existingFlow
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.checkoutSharedContent
                                            .confirmation_page.webinar_sign_up
                                        ) + " ⟶"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          : _vm.segment === "Industrial"
                          ? [
                              _c("div", { staticClass: "row center-xs" }, [
                                _c("div", { staticClass: "col xs-12" }, [
                                  _c("div", { staticClass: "video-info" }, [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.checkoutSharedContent
                                            .confirmation_page
                                            .industrial_confirmation
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row",
                                      attrs: { id: "button-container" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "checkout-button",
                                          attrs: {
                                            href: _vm.checkoutSharedContent
                                              .confirmation_page.referral_link,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.checkoutSharedContent
                                                .confirmation_page.refer_friend
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "checkout-button",
                                          attrs: {
                                            href: _vm.checkoutSharedContent
                                              .confirmation_page.kb_link,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.checkoutSharedContent
                                                .confirmation_page
                                                .knowledge_base
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: _vm.checkoutSharedContent
                                        .industrialConfirmationImage.fields.file
                                        .url,
                                    },
                                  }),
                                ]),
                              ]),
                            ]
                          : [
                              _c("div", { staticClass: "row center-xs" }, [
                                _c("div", { staticClass: "col xs-12" }, [
                                  _c("h5", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.checkoutSharedContent.watchDemo
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.checkoutSharedContent
                                          .samsaraForFleets
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(0),
                                ]),
                              ]),
                            ],
                        _vm._v(" "),
                        _vm.isSelfServiced
                          ? [
                              _c("hr"),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("h3", [_vm._v("Your Items")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col xs-12 md-12 lg-12",
                                    attrs: {
                                      id: "review-offers-in-cart-container",
                                    },
                                  },
                                  [
                                    _c("offers-in-cart", {
                                      attrs: { editable: false },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("address-confirmation", {
                          staticClass: "col xs-12 md-6 padding-top",
                          attrs: {
                            address: _vm.shipping,
                            title:
                              _vm.checkoutSharedContent.opportunityInfoHeaders
                                .shipping_confirmation,
                          },
                        }),
                      ]
                    : [
                        _c("div", { attrs: { id: "message" } }, [
                          _c("h1", { attrs: { id: "confirmation-title" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.checkoutSharedContent
                                  .paymentMethodUpdatedSuccessfully
                              )
                            ),
                          ]),
                        ]),
                      ],
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "video",
      {
        attrs: {
          preload: "preload",
          controls: "controls",
          width: "1920",
          height: "1080",
          playsinline: "",
          "webkit-playsinline": "",
          poster: "",
          src: "https://d9ylfbta65t3x.cloudfront.net/mov/demo-samsara_for_fleets.mp4",
        },
      },
      [
        _c("source", {
          attrs: {
            src: "https://d9ylfbta65t3x.cloudfront.net/mov/demo-samsara_for_fleets.mp4",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }